<template>
  <div id="online-data"
       class="home container-fluid">

    <div class="panel mb-3">

      <div class="row mb-2">
        <div class="col-12">
          <button class="btn btn-success float-right"
                  @click="refreshMids">
            <span class="mdi mdi-refresh"></span>
            <span class="d-none d-md-inline"> {{ $t('#TR-refresh') }}</span>
          </button>
        </div>
      </div>


      <div class="mid-grid">
        <b-card v-for="(mid, idx) in midServerList"
                :key="mid.guid"
                :header-text-variant="mid.loaded ? 'white' : 'dark'"
                :header-bg-variant="getColor(mid)"
                :border-variant="getColor(mid)"
                align="center"
                class="mid"
                :class="mid.isConnected ? 'mid-conected' : 'mid-disconected'"
                @click="onSelectMid(mid)">

          <template #header>
            <span class="font-weight-bold">{{ mid.name ? mid.name : mid.alias }}</span> <br>
            {{ mid.restaurantName }}
          </template>

          <b-card-text v-if="mid.loaded && mid.isConnected"
                       class="text-left">

            <div class="row small mb-2">
              <div class="col-6 text-right pr-0 text-nowrap text-truncate">
                {{ $t('#TR-shift') }}:
              </div>
              <div class="col-6">
                <b>{{ mid.shiftNum }}</b>
              </div>
            </div>

            <div class="row small mb-2">
              <div class="col-6 text-right pr-0 text-nowrap text-truncate">
                {{ $t('#TR-shift-date') }}:
              </div>
              <div class="col-6">
                <b>{{ mid.shiftDate | moment('DD.MM.YYYY') }}</b>
              </div>
            </div>

            <div class="row small mb-2">
              <div class="col-6 text-right pr-0 text-nowrap text-truncate">
                {{ $t('#TR-start-of-shift') }}:
              </div>
              <div class="col-6">
                <b>{{ mid.shiftStart | moment('DD.MM.YYYY, HH:mm') }}</b>
              </div>
            </div>

            <div class="row small mb-2">
              <div class="col-6 text-right pr-0 text-nowrap text-truncate">
                {{ $t('#TR-total-sum') }}:
              </div>
              <div class="col-6">
                <b>{{ mid.totalSum }}</b>
              </div>
            </div>

            <div class="row small">
              <div class="col-6 text-right pr-0 text-nowrap text-truncate">
                {{ $t('#TR-opened-tables') }}:
              </div>
              <div class="col-6">
                <b>{{ mid.openedTables }}</b>
              </div>
            </div>

          </b-card-text>

          <b-card-text v-if="mid.loaded && !mid.isConnected">
            <div class="small text-danger">
              {{ $t('#TR-connection-error') }}
            </div>
          </b-card-text>

          <b-card-text v-if="!mid.loaded">
            <div class="small color-blue-grey-700">
              <b-spinner small variant="grey" />
              <br>
              <br>
              {{ $t('#TR-loading') }}...
            </div>
          </b-card-text>


        </b-card>
      </div>

    </div>

  </div>
</template>

<script>
  import { ApiOnlineData } from '@/services/api';

  export default {
    name: '',
    data() {
      return {
        midServerList: []
      };
    },

    computed: {
      midServerSettings() {
        return this.$store.getters.getMidserverList;
      }
    },

    async created() {
      this.$store.commit('setPageTitle', this.$t('#TR-online-data'));

      await this.getEmptyList();
      this.getMidservers();
    },

    methods: {

      getEmptyList() {
        this.midServerList = [];
        this.midServerSettings.forEach(m => {
          this.midServerList.push({
            guid: m.guid,
            alias: m.alias,
            loaded: false
          });
        });
      },

      async refreshMids() {
        await this.getEmptyList();
        this.getMidservers();
      },

      getMidservers() {
        for (let i = 0; i < this.midServerSettings.length; i++) {
          const currentMid = this.midServerSettings[i];
          this.getMidServerData(currentMid);
        }
      },

      async getMidServerData(currentMid) {
        const result = await ApiOnlineData.mid(currentMid.guid);
        const findMid = this.midServerList.findIndex(m => m.guid === currentMid.guid);
        if (findMid !== -1) {
          this.midServerList[findMid].loaded = true;
          this.midServerList[findMid].isConnected = result.data.isConnected;
          this.midServerList[findMid].name = result.data.name;
          this.midServerList[findMid].shiftDate = result.data.shiftDate;
          this.midServerList[findMid].shiftNum = result.data.shiftNum;
          this.midServerList[findMid].shiftStart = result.data.shiftStart;
          this.midServerList[findMid].restaurantName = result.data.restaurantName;
          this.midServerList[findMid].totalSum = result.data.totalSum;
          this.midServerList[findMid].openedTables = result.data.openedTables;
        }

        // this.midServerList.push(mergedMid);
        // отсортируем по состоянию isConnected
        this.midServerList.sort((a, b) => b.isConnected - a.isConnected);
      },


      onSelectMid(mid) {
        if (!mid.isConnected) {
          return;
        }

        this.$router.push({
          name: 'online-data-orders',
          params: {
            mid: mid.guid
          }
        }).catch(() => {});
      },

      getColor(mid) {
        if (!mid.loaded) {
          return 'grey-300';
        }

        return mid.isConnected ? 'success' : 'danger';
      }

    }
  };
</script>

<style lang="stylus" scoped>
.mid-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 1rem;

  .mid {
    transition: all 300ms ease;
    color: blue-grey-300
  }

  .mid-conected {
    cursor: pointer;
    &:hover {
      transform: scale(1.05)
    }
  }

  .mid-disconected {
    opacity: 0.6;
  }

}


.darkmode {
  .mid {
    background: c-dark-bg
    color: c-body-font-dark !important
  }


  .mid-disconected {
    opacity: 0.7;
  }
}



</style>
